import { TaskTypes } from '../../../features/tasks/types/taskTypes';
import { TaskState } from '../../constants/states';
import {
  QuickFilters,
  QuickFilterType,
} from '../../interfaces/quickFilters/QuickFilters';
import { TaskQueryRequest } from '../../interfaces/quickFilters/TaskQueryRequest';
import {
  BuildTaskRequestsFilter,
  BuildTasksOrderedFilter,
  EspCMTasks,
  IntegraCMTasks,
  MostRecentFirst,
} from './configHelpers';

/*
  sectionName = APPLICATIONS and list item index = 0 must always be the legacy application view
  Therefore, the queryBody are all set as undefined.
*/

export const UnderwriterConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
  ],
};

export const ReferralUserConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
    {
      sectionName: 'Referral',
      list: [
        {
          display: 'Referred to you',
          quickFilterType: QuickFilterType.REFERRAL_VIEW,
          queryBody: {
            isReferralCase: true,
            filterReferralByCurrentUser: true,
          },
          title: 'Applications',
        },
      ],
    },
  ],
};

export const CasemanagerIntegraConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
    {
      sectionName: 'TASK REQUESTS',
      list: [...BuildTaskRequestsFilter(IntegraCMTasks)],
    },
    {
      sectionName: 'TASKS ORDERED',
      list: [...BuildTasksOrderedFilter(IntegraCMTasks)],
    },
    {
      sectionName: 'TASKS DONE',
      list: [
        {
          display: 'All',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: {
            taskType: IntegraCMTasks,
            taskState: [TaskState.FOR_REVIEW, TaskState.WAIVED],
            sort: MostRecentFirst,
          },
          title: 'All tasks done',
        },
      ],
    },
  ],
};

export const CasemanagerESPConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
    {
      sectionName: 'TASK REQUESTS',
      list: [...BuildTaskRequestsFilter(EspCMTasks)],
    },
    {
      sectionName: 'TASKS ORDERED',
      list: [...BuildTasksOrderedFilter(EspCMTasks)],
    },
    {
      sectionName: 'TASKS DONE',
      list: [
        {
          display: 'All',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: {
            taskType: EspCMTasks,
            taskState: [TaskState.FOR_REVIEW, TaskState.WAIVED],
            sort: MostRecentFirst,
          },
          title: 'All tasks done',
        },
      ],
    },
  ],
};

export const UwxConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
    {
      sectionName: 'MY TASKS',
      list: [
        {
          display: 'ETI requests',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: {
            taskType: [TaskTypes.ETI],
            taskState: [TaskState.REQUESTED],
            sort: MostRecentFirst,
          },
          title: 'ETI requests',
        },
        {
          display: 'Errored tasks',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: {
            taskState: [TaskState.ERROR],
            sort: MostRecentFirst,
          },
          title: 'Errored tasks',
        },
        {
          display: 'All evidence ordered',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: {
            taskState: [TaskState.ORDERED],
            sort: MostRecentFirst,
          },
          title: 'All evidence ordered',
        },
      ],
    },
  ],
};

export const DefaultConfig: QuickFilters = {
  section: [
    {
      sectionName: '',
      list: [
        {
          display: 'Applications',
          quickFilterType: QuickFilterType.TASK_LIST_VIEW,
          queryBody: undefined as any as TaskQueryRequest,
          title: 'Applications',
        },
      ],
    },
  ],
};
